<template>
  <div class="option" v-if="option">
    <div class="option_body">
      <div>
        <div style="display:inline-block;margin-left:auto;margin-right:0px;"><h5>Option : {{option.name}}</h5></div>
        <!-- <price style="display:inline-block;" :default_price="option.default_price" :default_price_list="option.default_price_list">
        </price> -->
      </div>
      <!-- <div v-if="option.help"></option>
        <p>{{option.help}}</p>
      </div> -->
    </div>
  </div>
</template>
<script>
import Price from "../Offer/Price"
export default {
  name:"Option",
  props:["contract_option"],
  components:{
    Price,
  },
  computed:{
    option() {
      return this.contract_option.option
    },
  },

}
</script>
<style scoped>
.option {
  /*width:50%;*/
}

.option_list {

}

.option_list_item {

}

</style>



// WEBPACK FOOTER //
// client/components/Demands/Details/ValidationRequestable/Contract/Option.vue